export const btnBorderRadius = '4px';
